import enCrtTranslations from './crt.json'
import enCrtAdditionalTranslations from './crt/index'

export { default as enAdmin } from './admin.json'
export { default as enAssortment } from './assortment.json'
export { default as enBanners } from './banners.json'
export { default as enCommon } from './common.json'
export { default as enCredit } from './credit/index'
export { default as enForms } from './forms.json'
export { default as enLaunches } from './launches.json'
export { default as enLogin } from './login.json'
export { default as enMaterials } from './materials.json'
export { default as enOperations } from './operations.json'
export { default as enOrders } from './orders.json'
export { default as enReports } from './reports.json'
export { default as enSoxCompliance } from './sox-compliance.json'
export { default as enStores } from './stores.json'
export { default as enStructural } from './structural.json'
export { default as enUploads } from './uploads.json'
export { default as enWelcome } from './welcome.json'

// The `crt` namespace is assembled from crt.json plus feature files split out of
// it (e.g. crt/bpc-actuals.json). crt.json stays at this level for now to avoid
// churn/merge conflicts;
export const enCrt = { ...enCrtTranslations, ...enCrtAdditionalTranslations }
